import type { ICol, IRow } from "../../interfaces";

export const getColsRecord = (cols: unknown): Record<string, ICol> => {
  if (!cols) return {};
  if (Array.isArray(cols)) {
    return cols.reduce<Record<string, ICol>>((acc, col, index) => {
      acc[String(index)] = col as ICol;
      return acc;
    }, {});
  }
  return cols as Record<string, ICol>;
};

/** All column definitions on a row, including every subrow. */
export const getAllRowCols = (row: IRow): ICol[] => {
  const cols = row.cols ? Object.values(getColsRecord(row.cols)) : [];
  const subrowCols =
    row.subrows?.flatMap(subrow => Object.values(getColsRecord(subrow.cols))) ??
    [];
  return [...cols, ...subrowCols];
};

/** Data columns used for sort keys — excludes header-style subrow cells. */
export const getSortableRowCols = (row: IRow): ICol[] =>
  getAllRowCols(row).filter(col => !col.headerStyle);

export const getRowTimeCol = (row: IRow): ICol | undefined =>
  getAllRowCols(row).find(
    col => col.NMEA === "_ROW_DATE_TIME" || col.NMEA === "ROW_TIME",
  );
